import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

const DeviceInfo = () => {
    const [deviceInfo, setDeviceInfo] = useState({
        deviceName: "Fetching...",
        model: "Fetching...",
        imei: "Fetching...",
    });
    const [scannerSerial, setScannerSerial] = useState("Fetching...");
    const [printerInfo, setPrinterInfo] = useState("Fetching...");

    useEffect(() => {
        if (isMobile) {
            getMobileDeviceInfo();
        } else {
            getConnectedDevices();
            requestPrinterAccess();
        }
    }, []);

    const getMobileDeviceInfo = async () => {
        try {
            if (window.cordova && window.device) {
                setDeviceInfo({
                    deviceName: window.device.manufacturer || "Unknown",
                    model: window.device.model || "Unknown",
                    imei: "Restricted (Use Native App)",
                });
            } else {
                const userAgent = navigator.userAgent;
                let deviceName = "Unknown Device";
                let model = "Unknown Model";

                if (/android/i.test(userAgent)) {
                    deviceName = "Android Device";
                    model = userAgent.match(/\(([^)]+)\)/)?.[1] || "Unknown";
                } else if (/iphone|ipad/i.test(userAgent)) {
                    deviceName = "iOS Device";
                    model = "iPhone/iPad";
                }

                setDeviceInfo({ deviceName, model, imei: "Restricted" });
            }
        } catch (error) {
            console.error("Error fetching mobile info:", error);
        }
    };

    const getConnectedDevices = async () => {
        try {
            if ("usb" in navigator) {
                const devices = await navigator.usb.getDevices();
                devices.forEach(device => {
                    console.log(`Connected USB device: ${device.productName} (${device.serialNumber || "No Serial"})`);
                    if (device.productName.toLowerCase().includes("scanner")) {
                        setScannerSerial(device.serialNumber || "Unknown Serial");
                    } else if (device.productName.toLowerCase().includes("printer")) {
                        setPrinterInfo(`Printer Found: ${device.productName} (Serial: ${device.serialNumber || "Unknown"})`);
                    }
                });
                if (devices.length === 0) {
                    setScannerSerial("No USB Devices Detected");
                    setPrinterInfo("No USB Devices Detected");
                }
            } else {
                setScannerSerial("WebUSB Not Supported");
                setPrinterInfo("WebUSB Not Supported");
            }
        } catch (error) {
            console.error("Error fetching connected devices:", error);
            setScannerSerial("Error: " + error.message);
            setPrinterInfo("Error: " + error.message);
        }
    };

    const requestPrinterAccess = async () => {
        try {
            const device = await navigator.usb.requestDevice({ filters: [] });
            console.log("User Granted Access:", device);
            getConnectedDevices(); // Fetch details after access granted
        } catch (error) {
            console.error("User denied USB access:", error);
            setPrinterInfo("USB Access Denied");
        }
    };

    return (
        <div>
            {isMobile ? (
                <div>
                    <h2>Mobile Device Details</h2>
                    <p><b>Device Name:</b> {deviceInfo.deviceName}</p>
                    <p><b>Model:</b> {deviceInfo.model}</p>
                    <p><b>IMEI:</b> {deviceInfo.imei}</p>
                </div>
            ) : (
                <div>
                    <h2>Desktop Device Details</h2>
                    <p><b>Scanner Serial Number:</b> {scannerSerial}</p>
                    <p><b>Printer Info:</b> {printerInfo}</p>
                    <button onClick={requestPrinterAccess}>Request Printer Access</button>
                </div>
            )}
        </div>
    );
};

export default DeviceInfo;
